/**
 * E9. Монета: стоимость позиции скрыта, пока не тапнуть «Посмотреть курс»
 * (так написано на экране). Тап показывает сумму; «Только посмотреть» сразу
 * закрывает игру исходом `{ view: true }` (тяга +2). Покупка ползунком,
 * «Продать всё». Один визит — один исход: если после просмотра купили
 * или продали, тяга за просмотр в этот исход не входит.
 */
import { t } from '@life/i18n';
import { CRYPTO_VIEW_URGE, type CryptoInput, type CryptoState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export function Crypto({ state, life, onInput }: MinigameScreenProps<CryptoInput, CryptoState>) {
  const cap = betCap(state.maxAmount, life.money);
  const [sum, setSum] = useBet(cap);
  const [viewed, setViewed] = useState(false);
  const hasCoin = state.held > 0;

  return (
    <>
      {hasCoin ? (
        viewed ? (
          <p class="mono">{t('ui.minigame.crypto.held', { sum: money(state.held) })}</p>
        ) : (
          <p>{t('ui.minigame.crypto.hidden', { urge: CRYPTO_VIEW_URGE })}</p>
        )
      ) : (
        <p>{t('ui.minigame.crypto.none')}</p>
      )}
      {hasCoin && !viewed && (
        <div class="picks">
          <button type="button" class="btn" onClick={() => setViewed(true)}>
            {t('ui.minigame.crypto.view')}
          </button>
          <button type="button" class="btn ghost" onClick={() => onInput({ view: true })}>
            {t('ui.minigame.crypto.viewOnly')}
          </button>
        </div>
      )}
      <Bet cap={cap} value={sum} onChange={setSum} label={t('ui.minigame.invest.sum')} />
      <div class="picks">
        <button type="button" class="btn accent" disabled={sum <= 0} onClick={() => onInput({ amount: sum })}>
          {t('ui.minigame.crypto.buy', { sum: money(sum) })}
        </button>
        {hasCoin && viewed && (
          <button type="button" class="btn" onClick={() => onInput({ sell: true })}>
            {t('ui.minigame.crypto.sell', { sum: money(state.held) })}
          </button>
        )}
      </div>
    </>
  );
}
